import React from 'react';
import Sidebar, { EXPANDED_WIDTH, COLLAPSED_WIDTH } from './Sidebar';
import { useSidebar } from '../../context/SidebarContext';

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const { collapsed } = useSidebar();
  const marginLeft = collapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH;

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar />
      <main style={{
        flex: 1,
        marginLeft: `${marginLeft}px`,
        display: 'flex',
        flexDirection: 'column',
        transition: 'margin-left 0.2s ease',
      }}>
        {children}
      </main>
    </div>
  );
};

export default AppLayout;
